module.exports = {
      id: "ic-otcbadge-usage",
      viewBox: "0 0 13 9",
      url: __webpack_public_path__ + "sprite-ad374a.smartcharts.svg#ic-otcbadge-usage",
      toString: function () {
        return this.url;
      }
    }